export default class Locale_LookupResource {
	IncludeInactiveResources: string = "Include inactive resources";
	ResourceTypes: string = "Resource types";
}